import React, { useState, useReducer, useRef, useEffect } from 'react'
import {
  TextField
} from '@material-ui/core'
import axios from 'axios'
import history from 'browserHistory'
import { useDispatch } from 'react-redux'
import useStyles from './styles'
import { formReducer, getFieldError } from 'helpers/forms'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { setWorkspace } from 'utils/auth/actions'
import Modal from 'components/Modal'
import IndustriesInput from 'components/IndustriesInput'
import AreasOfLawInput from 'components/AreasOfLawInput'
import Config from 'config'

const initFormsState = {
  errors: {}
}


const AddWorkspaceModal = (props) => {
  const {
    showDialog,
    setShowDialog,
    header
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [formErrors, dispatchFormErrors] = useReducer(formReducer, initFormsState)
  const [isLoading, setIsLoading] = useState(false)
  const [valueIndustries, setValueIndustries] = useState([])
  const [valueAreasOfLaw, setValueAreasOfLaw] = useState([])
  const [fileName, setFileName] = useState(null)

  useEffect(() => {
    dispatchFormErrors({ type: 'reset' })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  
  const formRef = useRef()

  const localClasses = useStyles()

  const addWorkspaceSubmit = (event) => {
    event.preventDefault()
    dispatchFormErrors({ type: 'reset' })
    setIsLoading(true)
    const url = `${apiUrl}workspaces/`
    const name = event.target.elements.name.value
    const industries = valueIndustries
    const areasOfLaw = valueAreasOfLaw
    const logos = event.target.elements.logo.files
    const formData = new FormData()
    formData.append('name', name)
    formData.append('areas_of_law', JSON.stringify(areasOfLaw))
    formData.append('industries', JSON.stringify(industries))
    if (logos && logos.length > 0) {
      formData.append('logo', logos[0])
    }
    axios.post(url, formData).then((body) => {
      const { data } = body
      dispatch(setSnackbar('Workspace created'))
      setIsLoading(false)
      dispatch(setWorkspace(data))
      history.push('/')
      setShowDialog(false)
    }).catch(err => {
      if (err.response) {
        dispatch(checkErrorStatus(err.response.status))
        setIsLoading(false)
        if (err.response.status === 400) {
          dispatchFormErrors({
            type: 'error',
            payload: err.response.data
          })
        } else {
          dispatchFormErrors({
            type: 'error',
            payload: {
              nonField: [err.response.data.detail]
            }
          })
        }
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      setFileName(file.name)
    } else {
      setFileName(null)
    }
  }

  return (
    <Modal
      open={showDialog}
      onClose={() => setShowDialog(false)}
      header={header}
      isLoading={isLoading}
      action={() => formRef.current.dispatchEvent(new Event('submit'))}
      actionText='Create'
    >
      <form onSubmit={addWorkspaceSubmit} ref={formRef}>
        { getFieldError(formErrors, 'nonField') ?
        <p className='error-message'>{getFieldError(formErrors, 'nonField')}</p> : null }

          <TextField
            className={localClasses.textField}
            required
            error={!!getFieldError(formErrors, 'name')}
            helperText={getFieldError(formErrors, 'name')}
            label='Workspace name'
            placeholder='E.g. Visiaw'
            type='text'
            color='secondary'
            name='name'
            fullWidth
            variant='outlined'
            InputLabelProps={{
              shrink: true,
              required: true
            }}
          />

          <div className={`${localClasses.fileInputFormControl} ${!!getFieldError(formErrors, 'logo') && 'error'}`} >
            <label className={localClasses.fileInputLabel} htmlFor='logo'>
              <span className={`${localClasses.labelImitation} labelImitation`}>
                Logo
              </span>
              {
                fileName ?
                  fileName :
                  <span className={localClasses.placeholderlImitation}>
                    No file submitted
                  </span>

              }
            </label>
            <input
              accept='.png,.jpg,.jpeg'
              onChange={handleFileChange}
              className={localClasses.fileInput}
              id='logo'
              name='logo'
              type='file'
              tabIndex='2'
            />
            <p className='error-message'>
              {
                getFieldError(formErrors, 'logo')
              }
            </p>
          </div>

          <AreasOfLawInput
            error={!!getFieldError(formErrors, 'areas_of_law')}
            helperText={getFieldError(formErrors, 'areas_of_law')}
            setValue={setValueAreasOfLaw}
            className={localClasses.textField}
            InputLabelProps={{
              shrink: true,
              required: true
            }}
          />

          <IndustriesInput
            error={!!getFieldError(formErrors, 'industries')}
            helperText={getFieldError(formErrors, 'industries')}
            setValue={setValueIndustries}
            className={localClasses.textField}
            InputLabelProps={{
              shrink: true,
              required: true
            }}
          />

      </form>
    </Modal>
  )
}

export default AddWorkspaceModal
